import useSWR, { useSWRConfig } from 'swr'
import useSWRImmutable from 'swr/immutable'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import { FAST_INTERVAL, SLOW_INTERVAL } from 'config/constants'

const getActiveBlockNumber = async (library, chainId?: number): Promise<number> => {
  return library.getBlockNumber()
}

export const usePollBlockNumber = () => {
  const { library, chainId } = useActiveWeb3React()
  const { cache, mutate } = useSWRConfig()
  const blockKey = chainId ? `blockNumber-${chainId}` : null
  const initialBlockKey = chainId ? `initialBlockNumber-${chainId}` : null

  return useSWR(
    blockKey,
    async () => {
      const blockNumber = await getActiveBlockNumber(library, chainId)

      if (initialBlockKey && !cache.get(initialBlockKey)) {
        mutate(initialBlockKey, blockNumber, false)
      }

      return blockNumber
    },
    {
      refreshInterval: FAST_INTERVAL,
      dedupingInterval: FAST_INTERVAL,
    },
  )
}

export const usePollBlockNumberSlow = () => {
  const { library, chainId } = useActiveWeb3React()
  const blockKey = chainId ? `blockNumber-${chainId}` : null

  return useSWR(
    blockKey,
    () => getActiveBlockNumber(library, chainId),
    {
      refreshInterval: SLOW_INTERVAL,
      dedupingInterval: SLOW_INTERVAL,
    },
  )
}

export const useCurrentBlock = (): number => {
  const { chainId } = useActiveWeb3React()
  const blockKey = chainId ? `blockNumber-${chainId}` : null
  const { data: currentBlock = 0 } = useSWRImmutable(blockKey)

  return currentBlock
}

export const useInitialBlock = (): number => {
  const { chainId } = useActiveWeb3React()
  const initialBlockKey = chainId ? `initialBlockNumber-${chainId}` : null
  const { data: initialBlock = 0 } = useSWRImmutable(initialBlockKey)

  return initialBlock
}
